<template>
    <HomeLayout>
        <Section
            hero-background
            repeat-background
            fullscreen
            padding-top-half
            padding-bottom-half
        >
            <Container>
                <SectionHeadline>Angaben zur Buchung</SectionHeadline>

                <CheckoutForm :booking="booking" />
            </Container>
        </Section>
    </HomeLayout>
</template>

<script>
import HomeLayout from "@/Layouts/HomeLayout.vue";
import Section from "@/Components/Section.vue";
import SectionHeadline from "@/Components/SectionHeadline.vue";
import Container from "@/Components/Container.vue";
import { Link } from "@inertiajs/inertia-vue3";
import StyledButton from "@/Components/StyledButton.vue";
import CheckoutForm from "@/Components/CheckoutForm.vue";

export default {
    components: {
        HomeLayout,
        Section,
        SectionHeadline,
        Container,
        CheckoutForm,
        StyledButton,
        Link,
    },

    props: {
        booking: {
            type: Object,
            required: true,
        },
    },
};
</script>
